module.exports = __webpack_public_path__ + "img/myh_corimg.d796ec55.jpg";